import { render, staticRenderFns } from "./headerTeacher.vue?vue&type=template&id=62c10cec&scoped=true"
import script from "./headerTeacher.vue?vue&type=script&lang=js"
export * from "./headerTeacher.vue?vue&type=script&lang=js"
import style0 from "./headerTeacher.vue?vue&type=style&index=0&id=62c10cec&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c10cec",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('62c10cec')) {
      api.createRecord('62c10cec', component.options)
    } else {
      api.reload('62c10cec', component.options)
    }
    module.hot.accept("./headerTeacher.vue?vue&type=template&id=62c10cec&scoped=true", function () {
      api.rerender('62c10cec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/headerTeacher.vue"
export default component.exports